import { NewsItem, IRemoteContent } from "./types.d";

const newsItems: NewsItem[] | [] = [];
const isLoading = false;
const remoteContent: IRemoteContent | {} = {};
const encodedImages = {};
const totalResults = 0;
const searchContinuationFields = [];
const searchTimeStamp = undefined;

export default {
  newsItems,
  isLoading,
  remoteContent,
  encodedImages,
  totalResults,
  searchContinuationFields,
  searchTimeStamp
};
